@if(gateService.loading()) {
  <div class="login-container">
    <!-- Left column: Brand showcase -->
    <div class="brand-column">
      <div class="guild-logo-wrapper">
        <img src="assets/images/guild-logo.svg" alt="The Guild" class="guild-main-logo">
      </div>

      <div class="brand-content">
        <h1 class="brand-title">The Guild</h1>
        <p class="brand-tagline">Building tools that make sense</p>

        <div class="brand-description">
          <p>One unified ecosystem of intuitive tools for creators, small teams, and entrepreneurs. No corporate bloat. No per-seat pricing. Just tools that work the way you do.</p>
        </div>

        <div class="showcase-stats">
          <div class="stat-item">
            <div class="stat-number">10k+</div>
            <div class="stat-label">Guild Members</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">3+</div>
            <div class="stat-label">Guild Tools</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">24/7</div>
            <div class="stat-label">Community</div>
          </div>
        </div>

        <div class="tools-showcase">
          <h3 class="tools-heading">Currently Available Guild Tools:</h3>
          <div class="tool-icons">
            <div class="tool-badge" title="ctrl - Project Management">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 11 12 14 22 4"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
              <span>ctrl</span>
            </div>
            <div class="tool-badge" title="Tavern - Community Portal">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>tavern</span>
            </div>
            <div class="tool-badge" title="War Room - Admin Portal">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
              </svg>
              <span>war room</span>
            </div>
          </div>
        </div>
      </div>

      <div class="brand-footer">
        <span>The Guild Mycelium LLC © 2025</span>
        <div class="footer-links">
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <a href="#">Contact</a>
        </div>
      </div>
    </div>

    <!-- Right column: Login form -->
    <div class="login-column">
      <div class="login-form-wrapper card">
        <div class="login-header">
          <div class="login-title-wrapper">
            <h2 class="login-title">Gateway Access</h2>
            <p class="login-subtitle">One account for all Guild tools</p>
          </div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <!-- Alert for error messages -->
          <div *ngIf="errorMessage" class="alert-message">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>{{ errorMessage }}</span>
          </div>

          <!-- Email input -->
          <div class="form-group">
            <label for="email">Email</label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <input
                type="email"
                id="email"
                formControlName="email"
                placeholder="your.email@example.com"
                [ngClass]="{'is-invalid': loginForm.get('email')?.invalid && loginForm.get('email')?.touched}"
              >
            </div>
            <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="form-error">
              <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</span>
              <span *ngIf="loginForm.get('email')?.errors?.['email']">Please enter a valid email</span>
            </div>
          </div>

          <!-- Password input -->
          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                formControlName="password"
                placeholder="Your password"
                [ngClass]="{'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}"
              >
              <button
                type="button"
                class="toggle-password"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              >
                <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </button>
            </div>
            <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="form-error">
              <span *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</span>
            </div>
          </div>

          <!-- Form actions -->
          <div class="form-actions">
            <div class="remember-me">
              <label class="checkbox-container">
                <input type="checkbox" [checked]="rememberMe" (change)="toggleRememberMe()">
                <span class="custom-checkbox"></span>
                <span class="checkbox-label">Remember me</span>
              </label>
            </div>
            <button type="button" class="forgot-link" (click)="forgotPassword()">Forgot password?</button>
          </div>

          <!-- Login button -->
          <button type="submit" style="width: 100%; margin-bottom: 24px" [disabled]="isLoading">
            <span *ngIf="!isLoading">Enter The Guild</span>
            <div *ngIf="isLoading" class="loader"></div>
          </button>

          <!-- Social login options -->
          <div class="social-login">
            <div class="separator">
              <span>Or continue with</span>
            </div>

            <div #googleSignInButton class="google-button-container"></div>
          </div>

          <!-- Register link -->
          <div class="register-section">
            <span>New to The Guild?</span>
            <button type="button" class="register-link" (click)="register()">Create your account</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Decorative elements -->
    <div class="decoration decoration-1"></div>
    <div class="decoration decoration-2"></div>
    <div class="guild-emblem"></div>
  </div>

}
